<template>
  <va-card color="background" style="padding: 0.75rem" class="xs3 md6">
    <div class="row">
      <div class="flex md12">
        <div class="selectionContainer">
          <va-accordion v-model="value" popout>
            <va-collapse v-for="(collapse, index) in collapses" :key="index" :header="collapse.title" popout
              color="#2E3C49" text-color="white">
              <div class="flex container">
                <div v-if="collapse.title == 'Configuration'">
                  <div class="row">
                    <div>
                      <va-select class="flex md-3" v-model="formatSelect.colour" textBy="description"
                        label="Select Color" :options="formatOptions.colour" />
                    </div>
                    <!-- show option -->
                    <div v-if="formatSelect.colour.description == 'Single'">
                      <va-advanced-color-picker v-model="formatSelect.colour.value" />
                    </div>
                    <div v-if="formatSelect.colour.description == 'Colour Map'">
                      <va-select class="flex md-3" v-model="formatSelect.colour.value" textBy="description"
                        label="Color Map" :options="colourMap" />
                    </div>
                    <!-- select option -->
                    <div>
                      <va-select class="flex md-3" v-model="formatSelect.scale" textBy="description"
                        :options="formatOptions.scale" label="Select Scale" />
                    </div>
                    <!-- show option -->
                    <div v-if="formatSelect.scale.id == 1 | formatSelect.scale.id == 2">
                      <va-input class="flex md-3" v-model="formatSelect.scale.value" type="number" min="1"
                        label="# of bins:" />
                    </div>
                    <div v-if="formatSelect.scale.id == 3">
                      <va-slider class="flex md-6" range v-model="formatSelect.scale.value" min="10" max="1000"
                        value-visible label="Min/max value:" />
                    </div>
                    <!-- Select size or opacity -->
                    <div v-if="selectedTabIndex == 0">
                      <va-input class="flex md-3" v-model="formatSelect.opacity.value" type="number" min="0" max="1"
                        placeholder="Input Opacity" label="Select Opacity:" />
                    </div>
                    <div v-if="selectedTabIndex == 1">
                      <va-input class="flex md-3" v-model="formatSelect.size.value" type="number" min="1"
                        placeholder="Input Size" label="Select Size:" />
                    </div>
                  </div>
                </div>
                <div v-if="collapse.title == 'Advanced Map Analysis'">
                  <va-card-content>
                    <div class="row">
                      <div class="flex xs12 md12">
                        <va-tabs center v-model="selectedTabIndex" style="width: 100%; min-width: 250px;"
                          :hide-slider="true">
                          <template #tabs>
                            <va-tab name="Region">
                              Region
                            </va-tab>
                            <va-tab name="Markers">
                              Markers
                            </va-tab>
                          </template>
                        </va-tabs>
                      </div>
                    </div>
                    <div>
                      <div v-show="selectedTabIndex === 'Region'" class="regionContainer">
                        <div class="region">
                          <div class="singleRegionContainer">
                            <h5>Left Region</h5>
                            <DataSelection id="left-region-select" :data_select="left_region_select"
                              @create_terria_layer="createTerriaLayer"
                              @update_level_one_selections="set_new_level_one_selections"
                              @update_level_two_selections="set_new_level_two_selections"></DataSelection>
                          </div>
                        </div>
                        <div class="region">
                          <div class="singleRegionContainer">
                            <h5>Right Region</h5>
                            <DataSelection id="right-region-select" :data_select="right_region_select"
                              @create_terria_layer="createTerriaLayer"
                              @update_level_one_selections="set_new_level_one_selections"
                              @update_level_two_selections="set_new_level_two_selections"></DataSelection>
                          </div>
                        </div>
                      </div>
                      <div v-show="selectedTabIndex === 'Markers'" class="regionContainer">
                        <div class="region">
                          <div class="singleRegionContainer">
                            <h5>Markers</h5>
                            <DataSelection id="marker-select" :data_select="marker_select"
                              @create_terria_layer="createTerriaLayer"
                              @update_level_one_selections="set_new_level_one_selections"
                              @update_level_two_selections="set_new_level_two_selections"></DataSelection>
                          </div>
                        </div>
                      </div>
                    </div>
                  </va-card-content>
                </div>
                <div v-if="collapse.title == 'Map Analysis'">
                  <div class="regionContainer">
                    <div class="region">
                      <div class="singleRegionContainer">
                        <h5>Population Shifting Analysis</h5>
                        <SimplifiedDataSelection id="mode-A" :data_select="A_region_select"
                          :mode_select="modeA_selected" @create_terria_layer="create_terria_layer_customs"
                          @update_level_one_selections="set_new_level_one_selections"
                          @update_level_two_selections="set_new_level_two_selections"></SimplifiedDataSelection>
                      </div>
                    </div>
                    <div class="region">
                      <div class="singleRegionContainer">
                        <h5>Overseas Born Population Analysis</h5>
                        <SimplifiedDataSelection id="mode-B" :data_select="B_region_select"
                          :mode_select="modeB_selected" @create_terria_layer="create_terria_layer_customs"
                          @update_level_one_selections="set_new_level_one_selections"
                          @update_level_two_selections="set_new_level_two_selections"></SimplifiedDataSelection>
                      </div>
                    </div>
                    <div class="region">
                      <div class="singleRegionContainer">
                        <h5>Population By Religion Analysis</h5>
                        <SimplifiedDataSelection id="mode-C" :data_select="C_region_select"
                          :mode_select="modeC_selected" @create_terria_layer="create_terria_layer_customs"
                          @update_level_one_selections="set_new_level_one_selections"
                          @update_level_two_selections="set_new_level_two_selections"></SimplifiedDataSelection>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </va-collapse>
          </va-accordion>
        </div>
      </div>
    </div>
  </va-card>
  <va-card color="background" style="padding: 0.75rem" class="xs3 md6">
    <div class="row">
      <div class="flex md10">
        <va-button-group gradient color="danger" class="mb-4" size="medium">
          <va-button @click="create_Join_Students">Show Joined Students </va-button>
          <va-button @click="create_Churn_Students">Show Churned Students </va-button>
          <va-button @click="create_Active_Students">Show Active Students </va-button>
        </va-button-group>
      </div>
      <div class="flex md2">
        <va-button-group gradient color="danger" class="mb-4" size="medium">
          <va-button class="mapButton" @click="create_Competitors_School">Show Competitors</va-button>
        </va-button-group>
      </div>
    </div>
  </va-card>
  <va-card color="background" style="padding: 0.75rem" class="xs3 md6">
    <div class="row map">
      <div class="flex xs12 md12" id="terria-map">
        <iframe id="embedded-terria-map" frameborder="0" :src="mapEntityIframeUri" style="height: 800px; width: 100%;"
          @load="mapEntityTerriaLayer"></iframe>
      </div>
    </div>
  </va-card>
</template>

<script>
import DataSelection from "@/modules/maps/components/data-select";
import SimplifiedDataSelection from "@/modules/maps/components/simple-data-select.vue";
//import LeafletMap from "../components/leaflet-select";
import { mapState, mapActions } from "vuex";
import { httpClient, MaphttpClient } from '@/shared/services/http-client'
import axios from 'axios'
import { config } from '@/config'
import { loadingService } from '@/shared/services/loading-service'

export default {
  name: "maps",
  components: {
    DataSelection,
    SimplifiedDataSelection
    //  LeafletMap,
  },
  data() {
    return {
      //Needed for terriajs configuration
      left_region_layer_count: -1, // Must start -1
      right_region_layer_count: -1, // Must start -1
      marker_layer_count: 0, // Must start 0

      value: [false, false, true],
      collapses: [
        { title: 'Configuration' },
        { title: 'Advanced Map Analysis' },
        { title: 'Map Analysis' }
      ],

      //Structure for tabs
      selectedDataSetIndex: 0,
      // mapStructureData: [{
      //     'value':'Left Region',
      //     'label':'Left Region',
      //     'data_select':null
      // },
      // {
      //     'value':'Right Region',
      //     'label':'Right Region',
      //     'data_select':null
      // },
      // {
      //     'value':'Markers',
      //     'label':'Markers',
      //     'data_select':null
      // }],
      leftRegionSelect: 0,
      rightRegionSelect: 1,
      markerSelect: 2,
      selectedTabIndex: "Region",
      tabOptions: ["Region", "Markers"],

      //   mapStructureData: [
      //     {
      //       value: "Left Region",
      //       label: "Left Region",
      //       data_select: null
      //     },
      //     {
      //       value: "Right Region",
      //       label: "Right Region",
      //       data_select: null
      //     },
      //     {
      //       value: "Markers",
      //       label: "Markers",
      //       data_select: null
      //     }
      //   ],

      //Structure for selects

      A_region_select: {
        type: "region",
        split: "LEFT",
        level_one_options: null,
        level_one_selected: null,
        level_two_options: null,
        level_two_labels: null,
        level_two_selected: null
      },

      B_region_select: {
        type: "region",
        split: "LEFT",
        level_one_options: null,
        level_one_selected: null,
        level_two_options: null,
        level_two_labels: null,
        level_two_selected: null
      },

      C_region_select: {
        type: "region",
        split: "LEFT",
        level_one_options: null,
        level_one_selected: null,
        level_two_options: null,
        level_two_labels: null,
        level_two_selected: null
      },


      left_region_select: {
        type: "region",
        split: "LEFT",
        level_one_options: null,
        level_one_selected: null,
        level_two_options: null,
        level_two_labels: null,
        level_two_selected: null
      },

      mapEntityIframeUri: process.env.VUE_APP_MAP_TERRIA_IFRAME_URL,
      mapapires: null,

      Marker_name: null,
      Layer_name: null,

      Join_data: null,
      Churn_data: null,
      Active_data: null,
      Competitors_data: null,

      modeA_selected: {
        mode: "modeA",
        state: null
      },
      modeB_selected: {
        mode: "modeB",
        state: null

      },
      modeC_selected: {
        mode: "modeC",
        state: null
      },

      right_region_select: {
        type: "region",
        split: "RIGHT",
        level_one_options: null,
        level_one_selected: null,
        level_two_options: null,
        level_two_labels: null,
        level_two_selected: null
      },

      marker_select: {
        type: "marker",
        split: null,
        level_one_options: null,
        level_one_selected: null,
        level_two_options: null,
        level_two_labels: null,
        level_two_selected: null
      },
      //Format strcture
      colourMap: ["red-white-hsl(240,50%,50%)", "green-orange"],
      formatSelect: {
        colour: {
          id: 1,
          description: "Colour Map",
          value: "red-white-hsl(240,50%,50%)"
        },
        scale: {
          id: 1,
          description: "Quantile",
          value: 10
        },
        opacity: {
          id: 1,
          description: "opacity",
          value: 1
        },
        size: {
          id: 1,
          description: "size",
          value: 3
        }
      },
      formatOptions: {
        colour: [
          {
            id: 1,
            description: "Colour Map",
            value: "red-white-hsl(240,50%,50%)"
          },
          {
            id: 2,
            description: "Single",
            value: "#ffd50a"
          }
        ],
        scale: [
          {
            id: 1,
            description: "Auto",
            value: 10
          },
          {
            id: 2,
            description: "Quantile",
            value: 10
          },
          {
            id: 3,
            description: "Min/Max",
            value: [20, 80]
          }
        ]
      }
    };
  },
  computed: {
    ...mapState({
      selectedEntity: state => state.user.selectedEntity,

      regionLevelOneData_A: state => state.maps.regionLevelOneData_A,
      regionLevelTwoData_A: state => state.maps.regionLevelTwoData_A,

      regionLevelOneData_B: state => state.maps.regionLevelOneData_B,
      regionLevelTwoData_B: state => state.maps.regionLevelTwoData_B,

      regionLevelOneData_C: state => state.maps.regionLevelOneData_C,
      regionLevelTwoData_C: state => state.maps.regionLevelTwoData_C,

      regionLevelOneData_left: state => state.maps.regionLevelOneData_left,
      regionLevelTwoData_left: state => state.maps.regionLevelTwoData_left,
      regionLevelOneData_right: state => state.maps.regionLevelOneData_right,
      regionLevelTwoData_right: state => state.maps.regionLevelTwoData_right,
      markerLevelOneData: state => state.maps.markerLevelOneData,
      markerLevelTwoData: state => state.maps.markerLevelTwoData,
      terriaLayer: state => state.maps.terriaLayer,
      entityTerriaLayer: state => state.maps.entityTerriaLayer,
      removeTerriaLayer: state => state.maps.removeTerriaLayer
    }),
    focused_school_id: function () {
      if (this.selectedEntity !== null) {
        return this.selectedEntity.industry_id;

      } else {
        return null;
      }
    }
  },

  async created() {
    await loadingService.showLoading(true);
    //Load region data
    this.load_map_student_data();
    await this.orch_load_level_data();

    await loadingService.showLoading(false);


  },

  watch: {
    //selectedTabIndex: function(new_value, old_value) {
    //   //Save old_value data
    //   if (old_value === 0) {
    //     this.mapStructureData[0].data_select = Object.assign(
    //       {},
    //       this.left_region_select
    //     );
    //   } else if (old_value === 1) {
    //     this.mapStructureData[1].data_select = Object.assign(
    //       {},
    //       this.right_region_select
    //     );
    //   } else if (old_value === 2) {
    //     this.mapStructureData[2].data_select = Object.assign(
    //       {},
    //       this.marker_select
    //     );
    //   }

    //Assign new_value data
    //   if (new_value === 0) {
    //       //this.leftRegionSelect += 1
    //       //this.rightRegionSelect += 1
    //     //this.reassign_data_select({ type: "region", split: "LEFT" });
    //     //this.reassign_data_select({ type: "region", split: "RIGHT" });
    //   } else if (new_value === 1) {
    //       //this.markerSelect += 1
    //     //this.reassign_data_select({ type: "marker", split: null });
    //   }
    // },
    focused_school_id: function () {
      if (this.focused_school_id) {
        this.orch_load_level_data();
        this.mapEntityTerriaLayer();
      }
    },

    regionLevelOneData_A: function () {
      this.A_region_select = {
        type: "region",
        split: "LEFT",
        level_one_options: this.regionLevelOneData_A.options,
        level_one_labels: this.regionLevelOneData_A.labels,
        level_one_selected: this.regionLevelOneData_A.selections,
        level_two_options: this.regionLevelTwoData_A.options,
        level_two_labels: this.regionLevelTwoData_A.labels,
        level_two_selected: this.regionLevelTwoData_A.selections
      };
    },
    regionLevelTwoData_A: function () {
      this.A_region_select = {
        type: "region",
        split: "LEFT",
        level_one_options: this.regionLevelOneData_A.options,
        level_one_labels: this.regionLevelOneData_A.labels,
        level_one_selected: this.regionLevelOneData_A.selections,
        level_two_options: this.regionLevelTwoData_A.options,
        level_two_labels: this.regionLevelTwoData_A.labels,
        level_two_selected: this.regionLevelTwoData_A.selections
      };
    },

    regionLevelOneData_B: function () {
      this.B_region_select = {
        type: "region",
        split: "LEFT",
        level_one_options: this.regionLevelOneData_B.options,
        level_one_labels: this.regionLevelOneData_B.labels,
        level_one_selected: this.regionLevelOneData_B.selections,
        level_two_options: this.regionLevelTwoData_B.options,
        level_two_labels: this.regionLevelTwoData_B.labels,
        level_two_selected: this.regionLevelTwoData_B.selections
      };
    },
    regionLevelTwoData_B: function () {
      this.B_region_select = {
        type: "region",
        split: "LEFT",
        level_one_options: this.regionLevelOneData_B.options,
        level_one_labels: this.regionLevelOneData_B.labels,
        level_one_selected: this.regionLevelOneData_B.selections,
        level_two_options: this.regionLevelTwoData_B.options,
        level_two_labels: this.regionLevelTwoData_B.labels,
        level_two_selected: this.regionLevelTwoData_B.selections
      };
    },

    regionLevelOneData_C: function () {
      this.C_region_select = {
        type: "region",
        split: "LEFT",
        level_one_options: this.regionLevelOneData_C.options,
        level_one_labels: this.regionLevelOneData_C.labels,
        level_one_selected: this.regionLevelOneData_C.selections,
        level_two_options: this.regionLevelTwoData_C.options,
        level_two_labels: this.regionLevelTwoData_C.labels,
        level_two_selected: this.regionLevelTwoData_C.selections
      };
    },
    regionLevelTwoData_C: function () {
      this.C_region_select = {
        type: "region",
        split: "LEFT",
        level_one_options: this.regionLevelOneData_C.options,
        level_one_labels: this.regionLevelOneData_C.labels,
        level_one_selected: this.regionLevelOneData_C.selections,
        level_two_options: this.regionLevelTwoData_C.options,
        level_two_labels: this.regionLevelTwoData_C.labels,
        level_two_selected: this.regionLevelTwoData_C.selections
      };
    },


    regionLevelOneData_left: function () {
      this.left_region_select = {
        type: "region",
        split: "LEFT",
        level_one_options: this.regionLevelOneData_left.options,
        level_one_labels: this.regionLevelOneData_left.labels,
        level_one_selected: this.regionLevelOneData_left.selections,
        level_two_options: this.regionLevelTwoData_left.options,
        level_two_labels: this.regionLevelTwoData_left.labels,
        level_two_selected: this.regionLevelTwoData_left.selections
      };
    },
    regionLevelTwoData_left: function () {
      this.left_region_select = {
        type: "region",
        split: "LEFT",
        level_one_options: this.regionLevelOneData_left.options,
        level_one_labels: this.regionLevelOneData_left.labels,
        level_one_selected: this.regionLevelOneData_left.selections,
        level_two_options: this.regionLevelTwoData_left.options,
        level_two_labels: this.regionLevelTwoData_left.labels,
        level_two_selected: this.regionLevelTwoData_left.selections
      };
    },
    regionLevelOneData_right: function () {
      this.right_region_select = {
        type: "region",
        split: "RIGHT",
        level_one_options: this.regionLevelOneData_right.options,
        level_one_labels: this.regionLevelOneData_right.labels,
        level_one_selected: this.regionLevelOneData_right.selections,
        level_two_options: this.regionLevelTwoData_right.options,
        level_two_labels: this.regionLevelTwoData_right.labels,
        level_two_selected: this.regionLevelTwoData_right.selections
      };
    },
    regionLevelTwoData_right: function () {
      this.right_region_select = {
        type: "region",
        split: "RIGHT",
        level_one_options: this.regionLevelOneData_right.options,
        level_one_labels: this.regionLevelOneData_right.labels,
        level_one_selected: this.regionLevelOneData_right.selections,
        level_two_options: this.regionLevelTwoData_right.options,
        level_two_labels: this.regionLevelTwoData_right.labels,
        level_two_selected: this.regionLevelTwoData_right.selections
      };
    },
    markerLevelOneData: function () {
      this.marker_select = {
        type: "marker",
        split: null,
        level_one_options: this.markerLevelOneData.options,
        level_one_labels: this.markerLevelOneData.labels,
        level_one_selected: this.markerLevelOneData.selections,
        level_two_options: this.markerLevelTwoData.options,
        level_two_labels: this.markerLevelTwoData.labels,
        level_two_selected: this.markerLevelTwoData.selections
      };
    },
    markerLevelTwoData: function () {
      this.marker_select = {
        type: "marker",
        split: null,
        level_one_options: this.markerLevelOneData.options,
        level_one_labels: this.markerLevelOneData.labels,
        level_one_selected: this.markerLevelOneData.selections,
        level_two_options: this.markerLevelTwoData.options,
        level_two_labels: this.markerLevelTwoData.labels,
        level_two_selected: this.markerLevelTwoData.selections
      };
    }
  },

  methods: {
    ...mapActions({
      loadLevelOneData: "maps/getLevelOneData",
      loadLevelTwoData: "maps/getLevelTwoData",
      reassignLevelOneData: "maps/reassignLevelOneData",
      reassignLevelTwoData: "maps/reassignLevelTwoData",
      loadTerriaLayer: "maps/getTerriaLayer",
      loadEntityTerriaLayer: "maps/getEntityTerriaLayer",
      loadRemoveTerriaLayer: "maps/getRemoveTerriaLayer"
    }),

    /*--------------------------------------------------------------------*/
    async load_map_student_data() {
      if (this.focused_school_id) {
        //----------------------------------------------------------------------------
        const url_map_join = `dashboard`;
        loadingService.showLoading(true);
        const body_map_join = {
          query: `
            query($id:Int!){
              presentMapPageQuery{
                StudentsJoin(id: $id){
                  JoinData
                } 
              }
            }
          `,
          variables: { 'id': this.focused_school_id }
        };

        const JoinJson = await httpClient.post(url_map_join, body_map_join)
        this.Join_data = JoinJson
        //.then(res=> this.mapapires=response.data)
        //----------------------------------------------------------------------------
        //----------------------------------------------------------------------------
        const url_map_Churn = `dashboard`;
        loadingService.showLoading(true);
        const body_map_Churn = {
          query: `
            query($id:Int!){
              presentMapPageQuery{
                StudentsChurn(id: $id){
                  ChurnData
                } 
              }
            }
          `,
          variables: { 'id': this.focused_school_id }
        };

        const ChurnJson = await httpClient.post(url_map_Churn, body_map_Churn)

        //.then(res=> this.mapapires=response.data)

        this.Churn_data = ChurnJson

        const url_map_active = `dashboard`;
        loadingService.showLoading(true);
        const body_map_active = {
          query: `
            query($id:Int!){
              presentMapPageQuery{
                StudentsActive(id: $id){
                  ActiveData
                } 
              }
            }
          `,
          variables: { 'id': this.focused_school_id }
        };

        const ActiveJson = await httpClient.post(url_map_active, body_map_active)
        //.then(res=> this.mapapires=response.data)
        this.Active_data = ActiveJson
        //----------------------------------------------------------------------------
        const url_map_competitors = `dashboard`;
        //loadingService.showLoading(true);
        const body_map_competitors = {
          query: `
            query($id:Int!){
              presentMapPageQuery{
                SchoolsCompetitor(id: $id){
                  SchoolCompetitorsData
                } 
              }
            }
          `,
          variables: { 'id': this.focused_school_id }
        };
        const CompetitorsJson = await httpClient.post(url_map_competitors, body_map_competitors)
        //.then(res=> this.mapapires=response.data)//console.log("repsonse", response))
        this.Competitors_data = CompetitorsJson
        //----------------------------------------------------------------------------
      }
    },

    async orch_load_level_data() {
      if (this.focused_school_id) {
        const params = {
          school_id: this.focused_school_id
        };
        //Load region data
        this.load_level_data({
          ...params,
          ...{ type: "region", split: "LEFT" }
        });
        this.load_level_data({
          ...params,
          ...{ type: "region", split: "RIGHT" }
        });
        this.load_level_data({ ...params, ...{ type: "marker", split: null } });

        this.load_level_data({ ...params, ...{ type: "region", split: "modeA" } });
        this.load_level_data({ ...params, ...{ type: "region", split: "modeB" } });
        await this.load_level_data({ ...params, ...{ type: "region", split: "modeC" } });
        await this.create_start_up_customs(this.A_region_select, "modeA");
      }
    },
    async load_level_data(params) {
      //Load level one
      await this.loadLevelOneData(params);

      //Then load level two
      if (params["type"] == "region") {
        if (params.split == "LEFT") {
          await this.load_level_two_data(
            params,
            this.regionLevelOneData_left.selections
          );
          //Save initial data load
          //   this.mapStructureData[0].data_select = Object.assign(
          //     {},
          //     this.left_region_select
          // );
        }
        else if (params.split == "RIGHT") {
          await this.load_level_two_data(
            params,
            this.regionLevelOneData_right.selections
          );
          //Save initial data load
          //   this.mapStructureData[1].data_select = Object.assign(
          //     {},
          //     this.right_region_select
          //   );
        }

        else if (params.split == "modeA") {
          await this.load_level_two_data(
            params,
            this.regionLevelOneData_A.selections
          );
          //Save initial data load
          //   this.mapStructureData[1].data_select = Object.assign(
          //     {},
          //     this.right_region_select
          //   );
        }

        else if (params.split == "modeB") {
          await this.load_level_two_data(
            params,
            this.regionLevelOneData_B.selections
          );
          //Save initial data load
          //   this.mapStructureData[1].data_select = Object.assign(
          //     {},
          //     this.right_region_select
          //   );
        }

        else if (params.split == "modeC") {
          await this.load_level_two_data(
            params,
            this.regionLevelOneData_C.selections
          );
          //Save initial data load
          //   this.mapStructureData[1].data_select = Object.assign(
          //     {},
          //     this.right_region_select
          //   );
        }
      }

      else if (params["type"] == "marker") {
        await this.load_level_two_data(
          params,
          this.markerLevelOneData.selections
        );
        //Save initial data load
        // this.mapStructureData[2].data_select = Object.assign(
        //   {},
        //   this.marker_select
        // );
      }
    },
    async load_level_two_data(params, selections) {
      if (
        this.focused_school_id &&
        "category" in selections &&
        "subcategory" in selections &&
        "metric" in selections
      ) {
        await this.loadLevelTwoData({ ...params, ...selections });
      }
    },

    /*--------------------------------------------------------------------*/
    async set_new_level_one_selections(params, new_selections) {
      //Get level two data based on new level one selections
      await this.load_level_two_data(
        { ...{ school_id: this.focused_school_id }, ...params },
        new_selections
      );

      //Check type
      if (params["type"] == "region") {
        //Check split side
        if (params["split"] == "LEFT") {
          this.left_region_select = Object.assign({}, this.left_region_select, {
            level_one_selected: new_selections
          });
        } else if (params["split"] == "RIGHT") {
          this.right_region_select = Object.assign(
            {},
            this.right_region_select,
            { level_one_selected: new_selections }
          );
        }
        else if (params["split"] == "modeA") {

          this.A_region_select = Object.assign({}, this.A_region_select, {
            level_one_selected: new_selections
          });
        }
        else if (params["split"] == "modeB") {

          this.B_region_select = Object.assign({}, this.B_region_select, {
            level_one_selected: new_selections
          });
        }
        else if (params["split"] == "modeC") {

          this.C_region_select = Object.assign({}, this.C_region_select, {
            level_one_selected: new_selections
          });
        }


      } else if (params["type"] == "marker") {
        this.marker_select = Object.assign({}, this.marker_select, {
          level_one_selected: new_selections
        });
      }
    },
    async set_new_level_two_selections(params, new_selections) {
      //Check type
      if (params["type"] == "region") {
        //Check split side
        if (params["split"] == "LEFT") {
          this.left_region_select = Object.assign({}, this.left_region_select, {
            level_two_selected: new_selections
          });
        } else if (params["split"] == "RIGHT") {
          this.right_region_select = Object.assign(
            {},
            this.right_region_select,
            { level_two_selected: new_selections }
          );
        }
        else if (params["split"] == "modeA") {

          this.A_region_select = Object.assign({}, this.A_region_select, {
            level_two_selected: new_selections
          });
        }
        else if (params["split"] == "modeB") {

          this.B_region_select = Object.assign({}, this.B_region_select, {
            level_two_selected: new_selections
          });
        }
        else if (params["split"] == "modeC") {

          this.C_region_select = Object.assign({}, this.C_region_select, {
            level_two_selected: new_selections
          });
        }

      } else if (params["type"] == "marker") {
        this.marker_select = Object.assign({}, this.marker_select, {
          level_two_selected: new_selections
        });
      }
    },

    /*  
    async reassign_data_select(params) {
      //Update data select
      if (params["type"] == "region") {
        if (params.split == "LEFT") {
          await this.reassignLevelOneData({
            ...params,
            ...{
              options: this.mapStructureData[0].data_select.level_one_options,
              labels: this.mapStructureData[0].data_select.level_one_labels,
              selections: this.mapStructureData[0].data_select
                .level_one_selected
            }
          });
          await this.reassignLevelTwoData({
            ...params,
            ...{
              options: this.mapStructureData[0].data_select.level_two_options,
              labels: this.mapStructureData[0].data_select.level_two_labels,
              selections: this.mapStructureData[0].data_select
                .level_two_selected
            }
          });
        } else if (params.split == "RIGHT") {
          await this.reassignLevelOneData({
            ...params,
            ...{
              options: this.mapStructureData[1].data_select.level_one_options,
              labels: this.mapStructureData[1].data_select.level_one_labels,
              selections: this.mapStructureData[1].data_select
                .level_one_selected
            }
          });
          await this.reassignLevelTwoData({
            ...params,
            ...{
              options: this.mapStructureData[1].data_select.level_two_options,
              labels: this.mapStructureData[1].data_select.level_two_labels,
              selections: this.mapStructureData[1].data_select
                .level_two_selected
            }
          });
        }
      } else if (params["type"] == "marker") {
        await this.reassignLevelOneData({
          ...params,
          ...{
            options: this.mapStructureData[2].data_select.level_one_options,
            labels: this.mapStructureData[2].data_select.level_one_labels,
            selections: this.mapStructureData[2].data_select.level_one_selected
          }
        });
        await this.reassignLevelTwoData({
          ...params,
          ...{
            options: this.mapStructureData[2].data_select.level_two_options,
            labels: this.mapStructureData[2].data_select.level_two_labels,
            selections: this.mapStructureData[2].data_select.level_two_selected
          }
        });
      }
    },
    */
    /*--------------------------------------------------------------------*/
    async createTerriaLayer(params, selected) {
      //This functon creates layer on terriajs

      if (this.focused_school_id) {
        //Collect layer data to post in http body
        const format = await this.loadTerriaFormat(params);

        //Load region data with api call
        const terria_params = {
          params: {
            ...{ school_id: this.focused_school_id },
            ...params
          },
          query: selected,
          format: format
        };
        await this.loadTerriaLayer(terria_params);
        //Send to iFrame
        // this.terriaLayer.showSplitter=false
        this.sendTerriaIFrame(this.terriaLayer);
      }
    },
    async mapEntityTerriaLayer() {
      //This functon maps the current school selected onto terria
      const terria_params = {
        params: {
          school_id: this.focused_school_id
        },
        format: {
          camera: {
            north: -8,
            east: 158,
            south: -45,
            west: 109
          },
          id: 0 //Always have school marked at zero, if school changed, this should replace previous
        }
      };
      await this.loadEntityTerriaLayer(terria_params);

      //Send to iFrame
      this.sendTerriaIFrame(this.entityTerriaLayer);
    },
    async removeLayer_fromTerria(id, layer_type, splitDirection) {
      //This functon removes layer from terriajs by specified index, layer_type and splitDirection
      //Sends no data to the existing layer
      const terria_params = {
        params: {
          school_id: this.focused_school_id,
          type: layer_type
        },
        format: {
          camera: {
            north: -8,
            east: 158,
            south: -45,
            west: 109
          },
          id: id,
          splitDirection: splitDirection
        }
      };
      await this.loadRemoveTerriaLayer(terria_params);

      //Send to iFrame
      this.sendTerriaIFrame(this.removeTerriaLayer);
    },
    async loadTerriaFormat(params) {
      //--------------------------
      //      Set layer info
      //--------------------------

      //Region layer
      if (params["type"] === "region") {
        //Left region
        if (params["split"] === "LEFT") {
          //Increase layer count
          this.left_region_layer_count += 1;
          const id = -2 * (this.left_region_layer_count + 1); //-2,-4,-6,-8 -- count will be first zero
          //Remove prior layer
          if (this.left_region_layer_count > 0) {
            await this.removeLayer_fromTerria(id + 2, "region", -1); //add 2 to get previous id
          }
          //Return new layer
          return {
            camera: {
              north: -8,
              east: 158,
              south: -45,
              west: 109
            },
            id: id,
            splitDirection: -1,
            name: "Left Region layer",
            regionTypeDimensionId: "sa2",
            formatSelect: this.formatSelect
            //'colorMap':'red-white-hsl(240,50%,50%)',
            //'colorBins':10,
          };
        }

        //Right region
        else if (params["split"] === "RIGHT") {
          //Increase layer count
          this.right_region_layer_count += 1;
          const id = -2 * this.right_region_layer_count - 1; //-1,-3,-5,-7 -- count will be first zero
          //Remove prior layer
          if (this.right_region_layer_count > 0) {
            await this.removeLayer_fromTerria(id + 2, "region", 1); //add 2 to get previous id
          }

          let name_val;
          switch (this.Layer_name) {
            case "modeA":
              // code block
              name_val = "Population Shifting Analysis"; //"Marker layer: "+this.marker_layer_count,
              break;

            case "modeB":
              // code block
              name_val = "Overseas Born Population Analysis"; //"Marker layer: "+this.marker_layer_count,
              break;

            case "modeC":
              // code block
              name_val = "Population By Religion Analysis"; //"Marker layer: "+this.marker_layer_count,
              break;

            default:
              // code block
              name_val = "Right Region layer";//"Marker layer: "+this.marker_layer_count,
          }


          //Return new layer
          return {
            camera: {
              north: -8,
              east: 158,
              south: -45,
              west: 109
            },
            id: id,
            splitDirection: 1,
            name: name_val,
            regionTypeDimensionId: "sa2",
            formatSelect: this.formatSelect
            //'colorMap':'red-white-hsl(240,50%,50%)',
            //'colorBins':10,
          };
        }
      }

      //Marker layer
      else if (params["type"] === "marker") {
        this.marker_layer_count += 1;
        //Remove prior layer
        // if (this.marker_layer_count > 1) {
        //   await this.removeLayer_fromTerria(
        //     this.marker_layer_count - 1,
        //     "marker",
        //     null
        //   );
        // }
        let name_val
        switch (this.Marker_name) {
          case 'Join_marker':
            // code block
            name_val = "Join Students"; //"Marker layer: "+this.marker_layer_count,
            break;

          case 'Churn_marker':
            // code block
            name_val = "Churn Students"; //"Marker layer: "+this.marker_layer_count,
            break;

          case 'Active_marker':
            // code block
            name_val = "Active Students"; //"Marker layer: "+this.marker_layer_count,
            break;
          case 'Competitors_marker':
            // code block
            name_val = "Competitors School"; //"Marker layer: "+this.marker_layer_count,
            break;


          default:
            // code block
            name_val = "Marker layer";//"Marker layer: "+this.marker_layer_count,
        }


        return {
          camera: {
            north: -8,
            east: 158,
            south: -45,
            west: 109
          },
          id: this.marker_layer_count, //1,2,3,4 -- count will be first one
          name: name_val, //"Marker layer: "+this.marker_layer_count,
          formatSelect: this.formatSelect
          /*'colorMap': 'red-white-hsl(240,50%,50%)',
                    'colorBins': 0,
                    'scale': 3,
                    'scaleByValue': true,*/
        };
      }

      //Item layer
      else if (params["type"] === "item") {
        //Might need to do this later....
        return {};
      }
    },


    async loadTerriaFormat_AggVer(params) {
      //--------------------------
      //      Set layer info
      //--------------------------

      //Region layer
      if (params["type"] === "region") {
        //Left region
        if (params["split"] === "LEFT") {
          //Increase layer count
          this.left_region_layer_count += 1;
          const id = -2 * (this.left_region_layer_count + 1); //-2,-4,-6,-8 -- count will be first zero
          //Remove prior layer
          if (this.left_region_layer_count > 0) {
            await this.removeLayer_fromTerria(id + 2, "region", -1); //add 2 to get previous id
          }
          //Return new layer
          return {
            camera: {
              north: -8,
              east: 158,
              south: -45,
              west: 109
            },
            id: id,
            splitDirection: -1,
            name: "Left Region layer",
            regionTypeDimensionId: "sa2",
            formatSelect: this.formatSelect
            //'colorMap':'red-white-hsl(240,50%,50%)',
            //'colorBins':10,
          };
        }

        //Right region
        else if (params["split"] === "RIGHT") {
          //Increase layer count
          this.right_region_layer_count += 1;
          const id = -2 * this.right_region_layer_count - 1; //-1,-3,-5,-7 -- count will be first zero
          //Remove prior layer
          if (this.right_region_layer_count > 0) {
            await this.removeLayer_fromTerria(id + 2, "region", 1); //add 2 to get previous id
          }
          //Return new layer
          return {
            camera: {
              north: -8,
              east: 158,
              south: -45,
              west: 109
            },
            id: id,
            splitDirection: 1,
            name: "Right Region layer",
            regionTypeDimensionId: "sa2",
            formatSelect: this.formatSelect
            //'colorMap':'red-white-hsl(240,50%,50%)',
            //'colorBins':10,
          };
        }
      }

      //Marker layer
      else if (params["type"] === "marker") {
        this.marker_layer_count += 1;
        //Remove prior layer
        if (this.marker_layer_count > 1) {
          await this.removeLayer_fromTerria(
            this.marker_layer_count - 1,
            "marker",
            null
          );
        }
        return {
          camera: {
            north: -8,
            east: 158,
            south: -45,
            west: 109
          },
          id: this.marker_layer_count, //1,2,3,4 -- count will be first one
          name: "Marker layer", //"Marker layer: "+this.marker_layer_count,
          formatSelect: this.formatSelect
          /*'colorMap': 'red-white-hsl(240,50%,50%)',
                    'colorBins': 0,
                    'scale': 3,
                    'scaleByValue': true,*/
        };
      }

      //Item layer
      else if (params["type"] === "item") {
        //Might need to do this later....
        return {};
      }
    },


    sendTerriaIFrame(layer) {
      //Post layer to terria map iframe window

      //layer.showSplitter=false
      const iframeWindow = document.getElementById("embedded-terria-map")
        .contentWindow;
      //if ( iframeWindow.readyState  == 'complete' ) { <--------- doesn't work from a different domain
      iframeWindow.postMessage(
        { initSources: [JSON.parse(JSON.stringify(layer))] },
        this.mapEntityIframeUri
      );
      //}
    },

    async create_start_up_customs(region_select, mode_selected) {
      const params = {
        type: "region",
        split: "RIGHT"
      };

      const url1 = '/benchmarkReport/filters/' + this.selectedEntity.industry_id
      const benchmarkSchoolFilterData = await httpClient.get(url1)

      this.modeA_selected.state = Object.values(benchmarkSchoolFilterData.data.acaraBenchmarkQuery.filterDefaultValues.stateDefaultOption[0])[0]
      this.modeB_selected.state = Object.values(benchmarkSchoolFilterData.data.acaraBenchmarkQuery.filterDefaultValues.stateDefaultOption[0])[0]
      this.modeC_selected.state = Object.values(benchmarkSchoolFilterData.data.acaraBenchmarkQuery.filterDefaultValues.stateDefaultOption[0])[0]

      const selected = {
        category: region_select.level_one_selected
          ? region_select.level_one_selected.category
          : [],
        subcategory: region_select.level_one_selected
          ? region_select.level_one_selected.subcategory
          : [],
        metric: region_select.level_one_selected
          ? region_select.level_one_selected.metric
          : [],
        dropdown1: region_select.level_two_selected
          ? region_select.level_two_selected.dropdown1
          : [],
        dropdown2: region_select.level_two_selected
          ? region_select.level_two_selected.dropdown2
          : [],
        dropdown3: region_select.level_two_selected
          ? region_select.level_two_selected.dropdown3
          : [],
        dropdown4: region_select.level_two_selected
          ? region_select.level_two_selected.dropdown4
          : [],
        dropdown5: region_select.level_two_selected
          ? region_select.level_two_selected.dropdown5
          : [],
        dropdown6: region_select.level_two_selected
          ? region_select.level_two_selected.dropdown6
          : []
      };
      this.create_terria_layer_customs(params, selected, mode_selected)

    },

    async create_terria_layer_customs(params, selected, mode_selected) {
      this.Layer_name = mode_selected
      if (mode_selected === "modeA") {
        //this.modeA_selected= {
        //  mode: "modeA",
        //  state: Object.values(benchmarkSchoolFilterData.data.acaraBenchmarkQuery.filterDefaultValues.stateDefaultOption[0])[0]
        //}

        selected.dropdown1 = [this.modeA_selected.state]
        selected.dropdown2 = ["SA2"]

        params.split = "RIGHT"
        this.createTerriaLayer(params, selected)
      }
      else if (mode_selected === "modeB") {
        //this.modeB_selected= {
        //  mode: "modeB",
        //  state: Object.values(benchmarkSchoolFilterData.data.acaraBenchmarkQuery.filterDefaultValues.stateDefaultOption[0])[0]
        //
        //}
        selected.dropdown1 = [this.modeB_selected.state]
        selected.dropdown2 = ["SA2"]

        params.split = "RIGHT"
        this.createTerriaLayer(params, selected)
      }
      else if (mode_selected === "modeC") {
        //this.modeC_selected= {
        //    mode: "modeC",
        //    state: Object.values(benchmarkSchoolFilterData.data.acaraBenchmarkQuery.filterDefaultValues.stateDefaultOption[0])[0]
        //  }
        selected.dropdown1 = [this.modeC_selected.state]
        selected.dropdown2 = ["SA2"]

        params.split = "RIGHT"
        this.createTerriaLayer(params, selected)
      }
    },

    create_terria_layer_RIGHT(layer) {
      const params_test = {
        type: "region",
        split: "RIGHT"
      };

      const selected_test = {
        category: ["Population"],
        dropdown1: ["VIC"],
        dropdown2: ["LGA"],
        dropdown3: ["Persons"],
        dropdown4: ["%"],
        dropdown5: ["2016"],
        dropdown6: ["2011"],
        metric: ["Australian Citizen"],
        subcategory: ["Australian Citizenship"]

      };

      this.createTerriaLayer(params_test, selected_test)
    },

    async create_Join_Students(layer) {

      this.Marker_name = 'Join_marker'
      loadingService.showLoading(true);
      const params_test = {
        type: "marker",
        split: ""
      };

      const selected_test = {
        category: ["School"],
        dropdown1: ["VIC"],
        dropdown2: ["Catholic"],
        dropdown3: ["Combined"],
        dropdown4: ["%"],
        dropdown5: ["2019"],
        dropdown6: ["2008"],
        metric: ["Bottom SEA Quarter (%)"],
        subcategory: ["School Profile"]
      };


      const format = await this.loadTerriaFormat(params_test);

      const terria_params = {
        params: {
          ...{ school_id: this.focused_school_id },
          ...params_test
        },
        query: selected_test,
        format: format
      };
      //Api call
      const url = '/map/terria/' + terria_params['params']['type'] + '/' + terria_params['params']['school_id'];
      const body = {
        "params": terria_params['query'],
        "format": terria_params['format']
      };
      const terriaLayer = await httpClient.post(url, body);

      const Mapbody = {
        "schoold Id": this.focused_school_id,
        "year from": selected_test.dropdown6,
        "year to": selected_test.dropdown5
      };

      //----------------------------------------------------------------------------
      const url_map = `dashboard`;
      loadingService.showLoading(true);
      const body_map = {
        query: `
          query($id:Int!){
            presentMapPageQuery{
              MetricsTest(id: $id){
                output
              } 
            }
          }
        `,
        variables: { 'id': this.focused_school_id }
      };


      //const dashboardJson = await httpClient.post( url_map, body_map )
      //.then(res=> this.mapapires=response.data)
      //----------------------------------------------------------------------------
      // var Map_API_URL='https://eduport-dev.azurewebsites.net/api/eduportmaphttptrigger'
      // const temp = await axios.post(Map_API_URL + "",  JSON.stringify(Mapbody), 
      //{ headers: { "Content-Type": "application/json; charset=UTF-8" },
      //  params: { code: 'WV0Ib5Swr4N73QJHt7/eksXpksqEjD0aWksJs2cC3Bxua8LdUxRn2A=='} //Add userID as a param 
      //}).then(response=> this.mapapires=response.data)

      //const temp = await MaphttpClient.post('',Mapbody);
      const text = this.Join_data.data.data.presentMapPageQuery.StudentsJoin.JoinData
      const result = text.split('\\n').join('\n');
      Object.values(terriaLayer.data.catalog)[0].data = result

      terriaLayer.data.showSplitter = false
      Object.values(terriaLayer.data.catalog)[0].idColumns = ['postcode']
      Object.values(terriaLayer.data.catalog)[0].tableStyle.scale = 0.05
      Object.values(terriaLayer.data.catalog)[0].tableStyle.imageUrl = "test/images/join.png"
      //Object.values(terriaLayer.data.catalog)[0].tableStyle.colorBins = 10
  //Object.values(terriaLayer.data.catalog)[0].tableStyle.colorMap = "#ffffff-#eafcd6-#e6f2d7-#def7d0-#dbf2c2-#d7e4ba-#c0e286-#d2e082-#c0d86a-#aad654-#8ec640"
      Object.values(terriaLayer.data.catalog)[0].tableStyle.colorBinMethod ="ckmeans"
      Object.values(terriaLayer.data.catalog)[0].tableStyle.scaleByValue = false
      Object.values(terriaLayer.data.catalog)[0].tableStyle.colorMap = [
             //   {
              //    "color": "rgba(221,235,235,.8)", //#fffff
              //      "offset": 0.0
              //  },
                {
                  "color": "rgba(142, 198, 64,.8)",   //8ec640
                    "offset": 0.1
                },
                {
                  "color": "rgba(131, 194, 65,.8)",  //83c241
                    "offset": 0.2
                },
                {
                  "color": "rgba(119, 190, 66,.8)",  //77be42
                    "offset": 0.3
                },
                {
                  "color": "rgba(108, 185, 68,.8)",  //6cb944
                    "offset": 0.4
                },
                {
                  "color": "rgba(96, 181, 69,.8)",  //60b545
                    "offset": 0.5
                },
                {
                  "color": "rgba(84, 176, 71,.8)",  //54b047
                    "offset": 0.6
                },
                {
                  "color": "rgba(71, 172, 72,.8)", //47ac48
                    "offset": 0.7 
                },
                {
                  "color": "rgba(57, 167, 73,.8)",  //39a749
                    "offset": 0.8
                },
                {
                  "color": "rgba(40, 163, 75,.8)",  //28a34b
                    "offset": .9
                },
                {
                  "color": "rgba(15, 158, 76,.8)", //0f9e4c
                    "offset": 1
                }
            ]
    
      //Check response
      if (terriaLayer["data"] !== null & terriaLayer["data"] !== undefined) {
        //context.commit('setTerriaLayer', terriaLayer["data"])
        this.sendTerriaIFrame(terriaLayer["data"]);
      }

      loadingService.showLoading(false);
      //this.createTerriaLayer(params_test, selected_test)
    },

    async create_Churn_Students(layer) {

      this.Marker_name = 'Churn_marker'
      loadingService.showLoading(true);
      const params_test = {
        type: "marker",
        split: ""
      };

      const selected_test = {
        category: ["School"],
        dropdown1: ["VIC"],
        dropdown2: ["Catholic"],
        dropdown3: ["Combined"],
        dropdown4: ["%"],
        dropdown5: ["2019"],
        dropdown6: ["2008"],
        metric: ["Bottom SEA Quarter (%)"],
        subcategory: ["School Profile"]
      };

      const format = await this.loadTerriaFormat(params_test);

      const terria_params = {
        params: {
          ...{ school_id: this.focused_school_id },
          ...params_test
        },
        query: selected_test,
        format: format
      };
      //Api call
      const url = '/map/terria/' + terria_params['params']['type'] + '/' + terria_params['params']['school_id'];
      const body = {
        "params": terria_params['query'],
        "format": terria_params['format']
      };
      const terriaLayer = await httpClient.post(url, body);

      const Mapbody = {
        "schoold Id": this.focused_school_id,
        "year from": selected_test.dropdown6,
        "year to": selected_test.dropdown5
      };

      //----------------------------------------------------------------------------
      const url_map = `dashboard`;
      loadingService.showLoading(true);
      const body_map = {
        query: `
          query($id:Int!){
            presentMapPageQuery{
              StudentsChurn(id: $id){
                output
              } 
            }
          }
        `,
        variables: { 'id': this.focused_school_id }
      };

      //const dashboardJson = await httpClient.post( url_map, body_map )
      //.then(res=> this.mapapires=response.data)

      //----------------------------------------------------------------------------
      // var Map_API_URL='https://eduport-dev.azurewebsites.net/api/eduportmaphttptrigger'
      // const temp = await axios.post(Map_API_URL + "",  JSON.stringify(Mapbody), 
      //{ headers: { "Content-Type": "application/json; charset=UTF-8" },
      //  params: { code: 'WV0Ib5Swr4N73QJHt7/eksXpksqEjD0aWksJs2cC3Bxua8LdUxRn2A=='} //Add userID as a param 
      //}).then(response=> this.mapapires=response.data)

      //const temp = await MaphttpClient.post('',Mapbody);
      const text = this.Churn_data.data.data.presentMapPageQuery.StudentsChurn.ChurnData
      const result = text.split('\\n').join('\n');

      Object.values(terriaLayer.data.catalog)[0].data = result

      terriaLayer.data.showSplitter = false
      Object.values(terriaLayer.data.catalog)[0].idColumns = ['postcode']
      Object.values(terriaLayer.data.catalog)[0].tableStyle.scale = 0.05
      Object.values(terriaLayer.data.catalog)[0].tableStyle.imageUrl = "test/images/churn.png"
      //Object.values(terriaLayer.data.catalog)[0].tableStyle.colorMap = "#FF0000"
      //Object.values(terriaLayer.data.catalog)[0].tableStyle.colorBins = 2
      Object.values(terriaLayer.data.catalog)[0].tableStyle.colorBinMethod ="ckmeans"
      Object.values(terriaLayer.data.catalog)[0].tableStyle.scaleByValue = false
      Object.values(terriaLayer.data.catalog)[0].tableStyle.colorMap = [
               // {
               //   "color": "rgba(222,226,228,.8)", //#fffff
               //     "offset": 0.0
               // },
                {
                  "color": "rgba(81, 108, 179,.8)",   //516cb3
                    "offset": 0.1
                },
                {
                  "color": "rgba(75, 102, 175,.8)",  //4b66af
                    "offset": 0.2
                },
                {
                  "color": "rgba(69, 95, 171,.8)",  //455fab
                    "offset": 0.3
                },
                {
                  "color": "rgba(63, 89, 167,.8)",  //3f59a7
                    "offset": 0.4
                },
                {
                  "color": "rgba(57, 83, 163,.8)",  //3953a3
                    "offset": 0.5
                },
                {
                  "color": "rgba(51, 77, 158,.8)",  //334d9e
                    "offset": 0.6
                },
                {
                  "color": "rgba(45, 70, 154,.8)", //2d469a
                    "offset": 0.7 
                },
                {
                  "color": "rgba(38, 64, 150,.8)",  //264096
                    "offset": 0.8
                },
                {
                  "color": "rgba(32, 58, 145,.8)",  //203a91
                    "offset": .9
                },
                {
                  "color": "rgba(25, 52, 141,.8)", //19348d
                    "offset": 1
                }
            ]

      //Check response
      if (terriaLayer["data"] !== null & terriaLayer["data"] !== undefined) {
        //context.commit('setTerriaLayer', terriaLayer["data"])
        this.sendTerriaIFrame(terriaLayer["data"]);
      }

      loadingService.showLoading(false);
      //this.createTerriaLayer(params_test, selected_test)
    },

    async create_Active_Students(layer) {

      this.Marker_name = 'Active_marker'
      loadingService.showLoading(true);
      const params_test = {
        type: "marker",
        split: ""
      };

      const selected_test = {
        category: ["School"],
        dropdown1: ["VIC"],
        dropdown2: ["Catholic"],
        dropdown3: ["Combined"],
        dropdown4: ["%"],
        dropdown5: ["2019"],
        dropdown6: ["2008"],
        metric: ["Bottom SEA Quarter (%)"],
        subcategory: ["School Profile"]
      };

      const format = await this.loadTerriaFormat(params_test);

      const terria_params = {
        params: {
          ...{ school_id: this.focused_school_id },
          ...params_test
        },
        query: selected_test,
        format: format
      };
      //Api call
      const url = '/map/terria/' + terria_params['params']['type'] + '/' + terria_params['params']['school_id'];
      const body = {
        "params": terria_params['query'],
        "format": terria_params['format']
      };
      const terriaLayer = await httpClient.post(url, body);

      const Mapbody = {
        "schoold Id": this.focused_school_id,
        "year from": selected_test.dropdown6,
        "year to": selected_test.dropdown5
      };

      // var Map_API_URL='https://eduport-dev.azurewebsites.net/api/eduportmaphttptrigger'
      // const temp = await axios.post(Map_API_URL + "",  JSON.stringify(Mapbody), 
      //{ headers: { "Content-Type": "application/json; charset=UTF-8" },
      //  params: { code: 'WV0Ib5Swr4N73QJHt7/eksXpksqEjD0aWksJs2cC3Bxua8LdUxRn2A=='} //Add userID as a param 
      //}).then(response=> this.mapapires=response.data)

      //const temp = await MaphttpClient.post('',Mapbody);

      const text = this.Active_data.data.data.presentMapPageQuery.StudentsActive.ActiveData
      //let result = text.replace(//gi, "/n");

      const result = text.split('\\n').join('\n');


      Object.values(terriaLayer.data.catalog)[0].data = result

      //Object.values(terriaLayer.data.catalog)[0].data='ACARA_ID,Latitude,Longitude,Year,value\n40000,-42.871256,147.371473,2008,10\n40001,-42.91615827,147.3527644,2008,11\n40002,-41.226741,146.438726,2008,12\n40003,-42.789375,147.248306,2008,13\n40000,-42.871256,147.371473,2009,10\n40001,-42.91615827,147.3527644,2009,11\n40002,-41.226741,146.438726,2009,12\n40003,-42.789375,147.248306,2009,13\n40000,-42.871256,147.371473,2010,10\n40001,-42.91615827,147.3527644,2010,11\n40002,-41.226741,146.438726,2010,12\n40003,-42.789375,147.248306,2010,13\n40000,-42.871256,147.371473,2011,10\n40001,-42.91615827,147.3527644,2011,11\n40002,-41.226741,146.438726,2011,12\n40003,-42.789375,147.248306,2011,13\n40000,-42.871256,147.371473,2012,10\n40001,-42.91615827,147.3527644,2012,11\n40002,-41.226741,146.438726,2012,12\n40003,-42.789375,147.248306,2012,13\n40000,-42.871256,147.371473,2013,10\n40001,-42.91615827,147.3527644,2013,11\n40002,-41.226741,146.438726,2013,12\n40003,-42.789375,147.248306,2013,13\n40000,-42.871256,147.371473,2014,10\n40001,-42.91615827,147.3527644,2014,11\n40002,-41.226741,146.438726,2014,12\n40003,-42.789375,147.248306,2014,13\n40000,-42.871256,147.371473,2015,10\n40001,-42.91615827,147.3527644,2015,11\n40002,-41.226741,146.438726,2015,12\n40003,-42.789375,147.248306,2015,13\n40000,-42.871256,147.371473,2016,10\n40001,-42.91615827,147.3527644,2016,11\n40002,-41.226741,146.438726,2016,12\n40003,-42.789375,147.248306,2016,13\n40000,-42.871256,147.371473,2017,10\n40001,-42.91615827,147.3527644,2017,11\n40002,-41.226741,146.438726,2017,12\n40003,-42.789375,147.248306,2017,13\n'
      //"School Name,Year,value,Latitude,Longitude\nschool1,2014,10,-37.74119138,144.9427365\nschool2,2015,10,-26.74119138,157.9427365\nschool3,2015,10,-28.74119138,155.9427365\n"

      terriaLayer.data.showSplitter = false

      Object.values(terriaLayer.data.catalog)[0].idColumns = ['postcode']
      Object.values(terriaLayer.data.catalog)[0].tableStyle.scale = .05
      Object.values(terriaLayer.data.catalog)[0].tableStyle.imageUrl = "test/images/active.png"
      //Object.values(terriaLayer.data.catalog)[0].tableStyle.colorMap = "rgba(64,192,190,.8)-rgba(45,73,84,.8)"
      //Object.values(terriaLayer.data.catalog)[0].tableStyle.colorBins = 10
      //"Code,Label,Value,Year,Latitude,Longitude\n48004,P-10,my school,2008,-28.036607,151.98635\n"
      Object.values(terriaLayer.data.catalog)[0].tableStyle.colorBinMethod ="ckmeans"
      Object.values(terriaLayer.data.catalog)[0].tableStyle.scaleByValue = false
      Object.values(terriaLayer.data.catalog)[0].tableStyle.colorMap = [
             //   {
             //    "color": "rgba(221,235,235,.8)", //#fffff
             //       "offset": 0
             //   },
                {
                  "color": "rgba(64, 192, 190,.8)",   //40c0be
                    "offset": 0.0
                },
             //   {
             //     "color": "rgba(59, 178, 180,.8)",  //3bb2b4
             //       "offset": 0.2
             //   },
             //   {
             //     "color": "rgba(56, 164, 170,.8)",  //38a4aa
             //       "offset": 0.3
             //   },
             //   {
             //     "color": "rgba(54, 150, 159,.8)",  //36969f
             //       "offset": 0.4
             //   },
             //   {
             //     "color": "rgba(53, 137, 148,.8)",  //358994
             //       "offset": 0.5
             //   },
             //   {
             //     "color": "rgba(52, 123, 136,.8)",  //347b88
             //       "offset": 0.6
             //   },
             //   {
             //     "color": "rgba(51, 110, 123,.8)", //336e7b
             //       "offset": 0.7 
             //   },
             //   {
             //     "color": "rgba(50, 98, 111,.8)",  //32626f
             //       "offset": 0.8
             //   },
             //   {
             //     "color": "rgba(48, 85, 97,.8)",  //305561
             //       "offset": .9
             //   },
                {
                  "color": "rgba(45, 73, 84,.8)", //2d4954
                    "offset": 1
               }
            ]


      //Check response
      if (terriaLayer["data"] !== null & terriaLayer["data"] !== undefined) {
        //context.commit('setTerriaLayer', terriaLayer["data"])
        this.sendTerriaIFrame(terriaLayer["data"]);
      }
      loadingService.showLoading(false);
      //this.createTerriaLayer(params_test, selected_test)
    },

    async create_Competitors_School(layer) {
      loadingService.showLoading(true);
      this.Marker_name = 'Competitors_marker'
      const params_test = {
        type: "marker",
        split: ""
      };

      const selected_test = {
        category: ["School"],
        dropdown1: ["VIC"],
        dropdown2: ["Catholic"],
        dropdown3: ["Combined"],
        dropdown4: ["%"],
        dropdown5: ["2019"],
        dropdown6: ["2008"],
        metric: ["Bottom SEA Quarter (%)"],
        subcategory: ["School Profile"]
      };
      const format = await this.loadTerriaFormat(params_test);
      const terria_params = {
        params: {
          ...{ school_id: this.focused_school_id },
          ...params_test
        },
        query: selected_test,
        format: format
      };
      //Api call
      const url = '/map/terria/' + terria_params['params']['type'] + '/' + terria_params['params']['school_id'];
      const body = {
        "params": terria_params['query'],
        "format": terria_params['format']
      };
      const terriaLayer = await httpClient.post(url, body);

      const Mapbody = {
        "schoold Id": this.focused_school_id,
        "year from": selected_test.dropdown6,
        "year to": selected_test.dropdown5
      };


      // const Map_API_URL = 'https://eduport-dev.azurewebsites.net/api/eduportmaphttptrigger'
      // const temp = await axios.post(Map_API_URL + "", JSON.stringify(Mapbody),
      //   {
      //     headers: { "Content-Type": "application/json; charset=UTF-8" },
      //     params: { code: 'WV0Ib5Swr4N73QJHt7/eksXpksqEjD0aWksJs2cC3Bxua8LdUxRn2A==' }, //Add userID as a param 
      //   }).then(response => this.mapapires = response.data)

      //const temp = await MaphttpClient.post('',Mapbody);

      const text = this.Competitors_data.data.data.presentMapPageQuery.SchoolsCompetitor.SchoolCompetitorsData
      const result = text.split('\\n').join('\n');

      Object.values(terriaLayer.data.catalog)[0].data = result

      terriaLayer.data.showSplitter = false

      Object.values(terriaLayer.data.catalog)[0].tableStyle.imageUrl = "test/images/competitors.png"
      //Object.values(terriaLayer.data.catalog)[0].idColumns = ['postcode']
      //Object.values(terriaLayer.data.catalog)[0].tableStyle.dataVariable = "ACARA_ID"
      Object.values(terriaLayer.data.catalog)[0].tableStyle.colorMap = "rgba(236,73,36,.8)"
      Object.values(terriaLayer.data.catalog)[0].tableStyle.scale = 1
      Object.values(terriaLayer.data.catalog)[0].tableStyle.colorBins = 2
      Object.values(terriaLayer.data.catalog)[0].tableStyle.scaleByValue = false
      

      //Check response
        console.log('----------------1882--------------------------',terriaLayer["data"])
      if (terriaLayer["data"] !== null & terriaLayer["data"] !== undefined) {
        //context.commit('setTerriaLayer', terriaLayer["data"])
        this.sendTerriaIFrame(terriaLayer["data"]);
      }

      loadingService.showLoading(false);
      //this.createTerriaLayer(params_test, selected_test)
    }

  }
};
</script>


<style lang="scss" scoped>
.regionContainer {
  display: flex;
  justify-content: space-evenly;
  // padding-bottom: 10vh;
  // background: rgb(48, 48, 66);
}

.region {
  margin: 10px;
  background: rgb(48, 48, 66);

  background: -moz-radial-gradient(circle, #2E3C49 0%, #1B1F22 89%);
  background: -webkit-radial-gradient(circle, #2E3C49 0%, #1B1F22 89%);
  background: radial-gradient(circle, #2E3C49 0%, #1B1F22 89%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#2E3C49", endColorstr="#1B1F22", GradientType=1);
  border-radius: 5px;

  color: white;
  box-shadow: 0px 5px 10px 0px black;
}

.singleRegionContainer {
  padding: 15px;
}

.selectionContainer {
  display: flex;
  justify-content: center;

}


.multiselect__content-wrapper {
  position: absolute;
  display: block;
  background: #ffffff;
  width: 100%;
  max-height: 140px !important;
  overflow: auto;
  border: 1px solid #e8e8e8;
  border-top: none;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  z-index: 50;
  -webkit-overflow-scrolling: touch;

}
</style>
